var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "profile-input-wrapper" },
    [
      _c(
        "profile-form",
        {
          ref: "form",
          attrs: { endpoint: "waterpreference" },
          on: {
            error: function ($event) {
              return _vm.$emit("done", $event)
            },
          },
        },
        [
          _c("form", { staticClass: "form" }, [
            _c("fieldset", [
              _c("legend", { staticClass: "sr-only" }, [
                _vm._v(_vm._s(_vm.inputTitle)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "profile-input-label" }, [
                _vm._v(_vm._s(_vm.listLabel)),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input radio" },
                [
                  _vm._l(_vm.waterTypes, function (type) {
                    return _c("label", { key: type.value }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.waterPreferenceId,
                            expression: "waterPreferenceId",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          name: "waterPreference",
                          id: type.value,
                          "data-val": "true",
                          "data-val-required": _vm.getValidationForField(
                            "required",
                            "waterPreference"
                          ),
                        },
                        domProps: {
                          value: type.value,
                          checked: _vm._q(_vm.waterPreferenceId, type.value),
                        },
                        on: {
                          change: function ($event) {
                            _vm.waterPreferenceId = type.value
                          },
                        },
                      }),
                      _vm._v(
                        "\n            " + _vm._s(type.label) + "\n          "
                      ),
                    ])
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "field-validation-valid",
                    attrs: {
                      "data-valmsg-for": "waterPreference",
                      "data-valmsg-replace": "true",
                    },
                  }),
                ],
                2
              ),
              _vm._v(" "),
              _c("input", {
                attrs: { type: "hidden", name: "isWaterPreference" },
                domProps: { value: true },
              }),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }